var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "item-wrap",
      on: {
        click: function ($event) {
          return _vm.selectCard(_vm.document)
        },
      },
    },
    [
      _c("div", { staticClass: "content-top" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isHideCheck,
                expression: "!isHideCheck",
              },
            ],
            staticClass: "lc-check",
            attrs: { id: "customBookmark" },
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.internalSelectedItems,
                  expression: "internalSelectedItems",
                },
              ],
              attrs: {
                type: "checkbox",
                name: "selected-items",
                "aria-pressed": _vm.isChecked ? "true" : "false",
              },
              domProps: {
                value: _vm.document,
                checked: Array.isArray(_vm.internalSelectedItems)
                  ? _vm._i(_vm.internalSelectedItems, _vm.document) > -1
                  : _vm.internalSelectedItems,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.internalSelectedItems,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = _vm.document,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.internalSelectedItems = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.internalSelectedItems = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.internalSelectedItems = $$c
                  }
                },
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "media-info" }, [
          _c("div", { staticClass: "info-item" }, [
            _c("div", { staticClass: "source" }, [
              _vm.document.favicon ||
              (_vm.document.url && _vm.document.url.startsWith("http"))
                ? _c("div", { staticClass: "source-img" }, [
                    _vm.document.favicon
                      ? _c("img", {
                          attrs: { src: _vm.document.favicon, alt: "" },
                          on: {
                            error: function ($event) {
                              _vm.document.favicon =
                                "https://www.google.com/s2/favicons?domain=" +
                                _vm.document.url
                            },
                          },
                        })
                      : _c("img", {
                          attrs: {
                            src:
                              "https://www.google.com/s2/favicons?domain=" +
                              _vm.document.url,
                            alt: "",
                          },
                        }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { class: _vm.document.type == "USERNOTE" ? "badge" : "" },
                [
                  _c("p", {
                    staticStyle: {
                      "white-space": "nowrap",
                      "max-width": "100px",
                      overflow: "hidden",
                      "text-overflow": "ellipsis",
                    },
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.document.type != "FILE"
                          ? _vm.ExtractHostname(
                              _vm.document.url,
                              _vm.document.author
                            )
                          : _vm.document.author
                      ),
                    },
                  }),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.document.addedAt && !_vm.document.noConvertTime
            ? _c(
                "div",
                {
                  staticClass: "info-item",
                  class: { customAfter: !_vm.document.author },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.processDatetime(_vm.document.addedAt)) +
                      "\n      "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.document.addedAt && _vm.document.noConvertTime
            ? _c("div", { staticClass: "info-item" }, [
                _vm._v(_vm._s(_vm.document.addedAt)),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm.isShowDelete
          ? _c("div", { staticClass: "lc-btn" }, [
              _c(
                "a",
                {
                  staticClass: "btn-close",
                  on: {
                    click: function ($event) {
                      return _vm.removeCard(_vm.document)
                    },
                  },
                },
                [_c("i", { staticClass: "icon-common icon-close" })]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isGoPage
          ? _c("div", { staticClass: "lc-btn" }, [
              _c(
                "a",
                {
                  staticClass: "btn-close",
                  on: {
                    click: function ($event) {
                      return _vm.goPage(_vm.document)
                    },
                  },
                },
                [_c("i", { staticClass: "icon-common icon-navigate" })]
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content-box", staticStyle: { "min-height": "105px" } },
        [
          _c("div", { staticClass: "lc-media" }, [
            _c(
              "div",
              { staticClass: "media-header" },
              [
                _vm.isGotoLink
                  ? _c(
                      "router-link",
                      {
                        staticClass: "media-title",
                        attrs: {
                          to: {
                            name: "Detail",
                            params: {
                              connectomeId: _vm.connectomeId,
                              feedId: _vm.document.id,
                              item: _vm.document,
                              name: "list-collection",
                            },
                          },
                          custom: "",
                          disabled: !_vm.isGotoLink,
                          event: _vm.isGotoLink ? "click" : "",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.document.title) +
                            "\n        "
                        ),
                      ]
                    )
                  : _c("a", { staticClass: "media-title" }, [
                      _c("p", {
                        domProps: { innerHTML: _vm._s(_vm.document.title) },
                      }),
                    ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "media-body" },
              [
                _c("div", { staticClass: "body-inner" }, [
                  _c("p", {
                    staticClass: "media-desc",
                    domProps: { innerHTML: _vm._s(_vm.document.content) },
                  }),
                ]),
                _vm._v(" "),
                _vm.document.images &&
                _vm.document.images.length > 0 &&
                _vm.document.images[0]
                  ? _c(
                      "router-link",
                      {
                        class:
                          _vm.document.type == "FILE"
                            ? "media-file"
                            : "media-img",
                        attrs: {
                          to: {
                            name: "Detail",
                            params: {
                              connectomeId: _vm.connectomeId,
                              feedId: _vm.document.id,
                              item: _vm.document,
                            },
                          },
                          custom: "",
                          disabled: !_vm.isGotoLink,
                          event: _vm.isGotoLink ? "click" : "",
                          id: "image",
                        },
                      },
                      [
                        _vm.document.searchType === "VIDEO"
                          ? _c("div", { staticClass: "icon-play" })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("img", {
                          style:
                            _vm.document.type == "FILE"
                              ? {}
                              : { width: "100%" },
                          attrs: { alt: "", src: _vm.document.images[0] },
                          on: {
                            error: function ($event) {
                              _vm.document.images = null
                            },
                          },
                        }),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }